<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M2 6.9v11q0 1.1 1 1.5c3 1.2 6 .4 9-.4 2.8-.7 5.5-1.5 8.3-.7.8.2 1.7-.3 1.7-1.2v-11q0-1.1-1-1.5c-3-1.2-6-.4-9 .4-2.8.7-5.5 1.5-8.3.7C2.9 5.5 2 6 2 6.9m4.4 10.8H4.2v-2.3q2 .2 2.2 2.3M4.2 11V8.6h2.2c0 1.2-1 2.3-2.2 2.3m13.4 4.5c0-1.2 1-2.3 2.2-2.3v2.3zm2.2-6.8q-2-.2-2.2-2.3h2.2zM15.3 12c0 2.2-1.5 4-3.3 4s-3.3-1.8-3.3-4 1.5-4 3.3-4 3.3 1.8 3.3 4"
    />
  </svg>
</template>
